import axios from '@/utils/axios'



export const updateCouponSwitch = data =>
  axios.post('/admin/coupon/updateStatus', data)
    .then(res => res.data)
export const ZgenerateCouponURLLink = data =>
  axios.post('/admin/Coupon/ZgenerateCouponURLLink', data)
    .then(res => res.data)

// 客户搜索
export const customerSearch = data =>
  axios.post('/crm/SearchGroup/customerSearch', data)
    .then(res => res.data)
// 更新优惠券短链接
export const updateShortUrl = data =>
  axios.post('/admin/Coupon/updateUrlLink', data)
    .then(res => res.data)

// 优惠券推广链接
export const generateCouponURLLink = data =>
  axios.post('/admin/Coupon/generateCouponURLLink', data)
    .then(res => res.data)

// 优惠券二维码
export const generateCouponQRCode = data =>
  axios.post('/admin/Coupon/generateCouponQRCode', data)
    .then(res => res.data)

// 优惠券二维码
export const getCardQrcode = data =>
  axios.post('/admin/Coupon/couponQrcode', data)
    .then(res => res.data)
// 优惠券列表
export const getCardList = data =>
  axios.post('/admin/coupon/index', data)
    .then(res => res.data)

// 优惠券导出
export const cardexport = data =>
  axios.post('/admin/coupon/export', data)
    .then(res => res.data)

// 优惠券详情
export const getCardDetail = data =>
  axios.post('/admin/coupon/detail', data)
    .then(res => res.data)

// 添加优惠券
export const createCard = data =>
  axios.post('/admin/coupon/create', data)
    .then(res => res)
// 更新优惠券
export const updateCard = data =>
  axios.post('/admin/coupon/update', data)
    .then(res => res)

// 删除优惠券
export const deleteCard = data =>
  axios.post('/admin/coupon/delete', data)
    .then(res => res)

// 优惠券发放
export const provide = data =>
  axios.post('/admin/coupon/provide', data)
    .then(res => res)

// 优惠券发放详情
export const provideCoupon = data =>
  axios.post('/admin/coupon/provideCoupon', data)
    .then(res => res)

// 优惠券发放详情
export const getWriteOff = data =>
  axios.post('/crm/customer/getWriteOff', data)
    .then(res => res)

// 优惠券发放详情
export const oneProvide = data =>
  axios.post('/admin/coupon/oneProvide', data)
    .then(res => res)